// extracted by mini-css-extract-plugin
export default {"unsuscribed":"unsubscribe_unsuscribed__WbcuC","icon":"unsubscribe_icon__RQcpb","email":"unsubscribe_email__pYCmM"};